<template>
  <daiban-tool :flow="flow"> </daiban-tool>
</template>
<script>
import daibanTool from "./daibanTool.vue";
export default {
  components: { daibanTool },
  data() {
    return {
      flow: {
        id: "1621061241873154050",
        name: "小修管理",
        name1: "小修待办处理",
      },
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/yhgl/daibanchuli1.vue